import FrameInfo from './FrameInfo';

export default FrameInfo;
